import { z } from "zod";
import { DELIVERABLE_STATUSES } from "../constants/index";
import { nonEmpty, uuid } from "./_primitives";

// CEO Rev 1.0 — Deliverables + Accomplishments (campaign-scoped workspace items).

export const createDeliverableSchema = z.object({
  title: nonEmpty,
  description: z.string().trim().optional(),
  status: z.enum(DELIVERABLE_STATUSES).default("not_started"),
  ownerUserId: uuid.nullable().optional(),
  dueDate: z.coerce.date().nullable().optional(),
});

export const updateDeliverableSchema = z.object({
  title: nonEmpty.optional(),
  description: z.string().trim().nullable().optional(),
  status: z.enum(DELIVERABLE_STATUSES).optional(),
  ownerUserId: uuid.nullable().optional(),
  dueDate: z.coerce.date().nullable().optional(),
});

export const createAccomplishmentSchema = z.object({
  title: nonEmpty,
  description: z.string().trim().optional(),
  occurredAt: z.coerce.date().optional(),
});

export const updateAccomplishmentSchema = z.object({
  title: nonEmpty.optional(),
  description: z.string().trim().nullable().optional(),
  occurredAt: z.coerce.date().optional(),
});

export type CreateDeliverableInput = z.infer<typeof createDeliverableSchema>;
export type UpdateDeliverableInput = z.infer<typeof updateDeliverableSchema>;
export type CreateAccomplishmentInput = z.infer<typeof createAccomplishmentSchema>;
export type UpdateAccomplishmentInput = z.infer<typeof updateAccomplishmentSchema>;
